@import "../../global/normalize.css";

:host {
  display: block;
  color: var(--ic-top-navigation-text);
  width: 100%;
  position: relative;

  --ic-typography-color: var(--ic-top-navigation-text);
  --ic-button-secondary-text-monochrome: var(--ic-brand-text-color);
  --ic-button-secondary-border-monochrome: var(--ic-brand-text-color);
  --navigation-link-colour: var(--ic-top-navigation-text);
  --ic-top-navigation-status-tag-text: var(--ic-color-text-primary-light);
  --ic-top-navigation-status-tag-secondary: var(--ic-state-layer-lighten-20);
}

:host(.dark) {
  --ic-top-navigation-status-tag-text: var(--ic-color-text-primary-dark);
  --ic-top-navigation-status-tag-secondary: var(--ic-state-layer-darken-10);
  --ic-top-navigation-title-hover: var(--ic-action-dark-bg-hover);
  --ic-top-navigation-title-pressed: var(--ic-action-dark-bg-pressed);
}

:host(.dark) ::slotted(ic-navigation-button) {
  --ic-button-icon-monochrome: var(--ic-color-text-primary-light);
}

::slotted(ic-navigation-button) {
  --ic-button-icon-monochrome: white;
}

:host .top-navigation {
  background-color: var(--ic-top-navigation-background);
  height: max-content;
}

:host(.fullwidth-searchbar) slot[name="search"]::slotted(form) {
  width: 100%;
}

:host .title-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  padding: var(--ic-space-xxs);
  transition: var(--ic-easing-transition-fast);
}

:host .title-link,
:host .title-link:visited,
:host .title-link:active,
:host .title-link ::slotted(a),
:host .title-link:visited ::slotted(a),
:host .title-link:active ::slotted(a) {
  color: var(--ic-top-navigation-icon-and-label);
  text-decoration: none;
  outline: none;

  --ic-typography-color: var(--ic-top-navigation-icon-and-label);
}

:host .title-link:hover:not(:focus) {
  background-color: var(--ic-top-navigation-title-hover);
}

:host .title-link:active:not(:focus) {
  background-color: var(--ic-top-navigation-title-pressed);
}

:host .title-link:hover {
  border-radius: var(--ic-border-radius);
}

:host .menu-button-container {
  --ic-button-secondary-text-monochrome: var(--ic-brand-text-color);
  --ic-button-secondary-border-monochrome: var(--ic-brand-text-color);
}

:host .title-link:focus,
:host .title-link:focus-within {
  border-radius: var(--ic-border-radius);
  box-shadow: var(--ic-border-focus);
  outline: var(--ic-hc-focus-outline);
}

:host .title-link ic-typography {
  font-weight: 600;
}

:host .nav-panel-container {
  border-top: var(--ic-space-1px) solid var(--ic-top-navigation-keyline);
  padding: 0 var(--ic-space-lg);
  margin-left: calc(-1 * var(--section-container-margin));
  margin-right: calc(-1 * var(--section-container-margin));
  display: flex;
}

:host(.dark) .nav-panel-container {
  border-top: var(--ic-border-keyline-darken);
}

.top-panel-container {
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navigation-tabs {
  margin-top: calc(-1 * var(--ic-space-1px));
}

.app-details-container {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  margin-right: var(--ic-space-md);
}

.app-icon-container {
  display: flex;
  padding-right: var(--ic-space-xs);
}

.icon-buttons-container {
  display: flex;
  margin-left: var(--ic-space-md);
}

.icon-buttons-container ::slotted(nav) {
  display: flex;
}

.title-wrap {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}

:host .app-status {
  border-radius: var(--ic-space-md);
  background-color: var(--ic-top-navigation-status-tag);
  color: var(--ic-top-navigation-status-tag-text);

  --ic-typography-color: var(--ic-top-navigation-status-tag-text);

  padding: var(--ic-space-xxs) var(--ic-space-lg);
  margin-left: var(--ic-space-md);
  flex: 1 1 0;
  max-width: fit-content;
}

:host .app-version {
  border-radius: var(--ic-space-md);
  background-color: var(--ic-top-navigation-status-tag-secondary);
  color: var(--ic-top-navigation-status-tag);
  padding: var(--ic-space-xxs) var(--ic-space-sm);
  margin-left: var(--ic-space-xs);
  flex: 1 1 0;
  max-width: fit-content;

  --ic-typography-color: var(--ic-top-navigation-status-tag);
}

slot[name="app-icon"]::slotted(*) {
  fill: var(--ic-top-navigation-logo);
  width: 2em;
  height: 2em;
  cursor: pointer;
}

slot[name="toggle-icon"] svg {
  fill: var(--ic-top-navigation-icon);
}

.search-menu-container {
  justify-content: right;
  display: flex;
  align-items: center;
}

.menu-button-container {
  margin-left: var(--ic-space-md);
}

.menu-button-container .navigation-landmark-button-text {
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  color: var(--ic-brand-text-color);
}

.menu-button-container .navigation-landmark-button-text:dir(rtl) {
  right: -9999px;
}

.search-actions-container {
  display: flex;
}

.menu-buttons-slot {
  display: flex;
  flex-direction: column;
}

.navigation-landmark-text {
  position: absolute;
  width: var(--ic-space-1px);
  height: var(--ic-space-1px);
  padding: 0;
  margin: calc(-1 * var(--ic-space-1px));
  overflow: hidden;
}

.navigation-item-list {
  display: flex;
  list-style: none;
  height: 2.75rem;
}

.navigation-item-list::-webkit-scrollbar {
  display: none;
}

:host ic-section-container {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

@media screen and (min-width: 993px) {
  .app-details-container {
    margin-right: var(--ic-space-lg);
  }
}

/* large */
@media screen and (max-width: 1200px) {
  :host .nav-panel-container {
    padding: 0 var(--ic-space-md);
  }
}

/** Mobile styling **/
:host(.mobile-mode) .app-status,
:host(.mobile-mode) .app-version {
  display: none;
}

:host(.mobile-mode) .title-link {
  margin-right: var(--ic-space-xs);
}

:host(.mobile-mode) .search-menu-container {
  max-width: 10rem;
}

:host(.mobile-mode) .search-bar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: var(--ic-border-keyline-darken);
  height: 4rem;
  padding-left: var(--ic-space-md);
  padding-right: var(--ic-space-md);
  margin-left: calc(-1 * var(--section-container-margin));
  margin-right: calc(-1 * var(--section-container-margin));
}

/* x small */
@media screen and (max-width: 576px) {
  :host .title-link {
    margin-right: var(--ic-space-xxxs);
    word-break: break-word;
    hyphens: none;
  }

  .top-panel-container {
    min-height: 2.5rem;
  }

  .search-bar-container {
    margin-top: 0;
    height: 3.5rem;
    padding-left: var(--ic-space-xs);
    padding-right: var(--ic-space-xs);
  }

  .menu-button-container {
    margin-left: var(--ic-space-sm);
  }

  slot[name="app-icon"]::slotted(*) {
    width: 1.5em;
    height: 1.5em;
  }

  slot[name="toggle-icon"] svg {
    width: 1.5em;
    height: 1.5em;
  }
}

@media (forced-colors: active) {
  :host .top-navigation {
    border-bottom: var(--ic-border-hc);
  }

  .app-status,
  .app-version {
    border: var(--ic-border-hc);
  }

  slot[name="app-icon"]::slotted(*) {
    fill: currentcolor;
  }

  slot[name="toggle-icon"] svg {
    fill: currentcolor;
  }
}

@media (prefers-reduced-motion: reduce) {
  :host .title-link {
    transition: none;
  }
}
